export default "__VITE_ASSET__DRqtumq___"